import pb from '../pocketbase';

let memoryKey = null;

// Helper to convert ArrayBuffer to Base64
function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

// Helper to convert Base64 to ArrayBuffer
function base64ToArrayBuffer(base64) {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

async function getUserId() {
  if (!pb.authStore.isValid) throw new Error('User not authenticated');
  return pb.authStore.model.id;
}

export async function getEncryptionKey() {
  if (memoryKey) return { key: memoryKey };

  const userId = await getUserId();

  // Try to fetch from PocketBase
  let data = null;
  try {
    const records = await pb.collection('encryption_keys').getList(1, 1, {
      filter: `user = '${userId}'`,
    });
    if (records.items.length > 0) {
      data = records.items[0];
    }
  } catch (error) {
    // Collection might not exist yet or no records
    console.log('No encryption key found, will generate new one');
  }

  let keyB64;

  if (data) {
    keyB64 = data.key_b64;
  } else {
    // Generate new key if not found
    const key = await window.crypto.subtle.generateKey(
      {
        name: "AES-GCM",
        length: 256
      },
      true,
      ["encrypt", "decrypt"]
    );

    const exportedKey = await window.crypto.subtle.exportKey("raw", key);
    keyB64 = arrayBufferToBase64(exportedKey);

    // Save to PocketBase
    try {
      await pb.collection('encryption_keys').create({
        user: userId,
        key_b64: keyB64
      });
    } catch (insertError) {
      console.error('Error saving encryption key:', insertError);
      // Continue anyway - key is in memory
    }
  }

  // Import key for use
  const keyBuffer = base64ToArrayBuffer(keyB64);
  memoryKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-GCM" },
    false,
    ["encrypt", "decrypt"]
  );

  return { key: memoryKey };
}

export async function encryptNoteContent(content) {
  if (!content) return null;

  const { key } = await getEncryptionKey();
  const encoded = new TextEncoder().encode(content);
  const iv = window.crypto.getRandomValues(new Uint8Array(12));

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv
    },
    key,
    encoded
  );

  return {
    content_ciphertext: arrayBufferToBase64(encryptedBuffer),
    content_iv: arrayBufferToBase64(iv),
    content_algo: 'AES-GCM-256',
    content_key_version: 1
  };
}

export async function decryptNoteContent(ciphertext, ivB64) {
  if (!ciphertext || !ivB64) return "";

  try {
    const { key } = await getEncryptionKey();

    const iv = base64ToArrayBuffer(ivB64);
    const encrypted = base64ToArrayBuffer(ciphertext);

    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv
      },
      key,
      encrypted
    );

    return new TextDecoder().decode(decryptedBuffer);
  } catch (error) {
    console.error('Decryption failed:', error);
    return '[Ошибка расшифровки]';
  }
}
